import { buildExportColumns, escapeCSV } from './reportHelpers';

export const handleExcelExport = (visibleData, formatShortDate) => {
    if (!visibleData || visibleData.length === 0) {
        window.alert('No data available to export.');
        return;
    }

    const columns = buildExportColumns(formatShortDate);

    const csvRows = [
        columns.map(c => c.header).join(','),
        ...visibleData.map(row =>
            columns.map(c => {
                const raw = row[c.key];
                const val = c.format ? c.format(raw) : raw;
                return escapeCSV(val);
            }).join(',')
        )
    ];
    const csvContent = csvRows.join('\n');

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const dateStr = new Date().toISOString().split('T')[0];
    const link = document.createElement('a');
    link.href = url;
    link.download = `costing-report-${dateStr}.csv`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
};
